import React from "react";
import Index from "./Index";
import { contentLayout, modules } from "../config/pages";
import { useUser } from "../contexts/UserContext";
import Forbidden from "./Forbidden";

function Traceability() {
  const { user } = useUser();
  let view = contentLayout[modules.Traceability];
  if (user.permissions.views.length && !user.permissions.views.join().includes(modules.Traceability.toLowerCase())) {
    view = Forbidden
  }
  return <Index content={view} module={modules.Traceability} />;
}

export default Traceability;
